<div class="container">
  <div class="header">
    <span class="title">Filters</span>
    <button class="close-btn" (click)="closeModal()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="body" [class.has-dropdowns]="dropdownsOptions().length > 0">
    @if (topDropdowns().length > 0) {
      @for (dd of topDropdowns(); track dd.key) {
        <app-dropdown
          [label]="dd.label"
          [placeholder]="dd.placeholder"
          [options]="dd.options"
          [type]="dd.type"
          [ngModel]="dropdownModels().get(dd.key)"
          (ngModelChange)="onDropdownModelChange(dd, $event)"
          [name]="dd.key"
          [isSearch]="dd.isSearch || false"
          [isFilterClass]="dd.isFilterClass || false"
        ></app-dropdown>
      }
    } @if (dateFilters().length > 0) {
    <div class="date">
      @for (dateFilter of dateFilters(); track dateFilter.key) {
      <app-date-picker
        [datePickerMode]="'dropdown'"
        [dateFilter]="dateFilter"
        (rangeChange)="onDateRangeSelected($event, dateFilter.key)"
      ></app-date-picker>
      }
    </div>
    } @for (filter of filters; track filter.name) { @if (shouldShowFilter(filter.name)) {
    <div class="filter">
      <span class="filter-label">{{ filter.name }}</span>
      <div class="filter-options">
        @for (field of filter.filterFields; track field.value) {
        <label class="custom-checkbox">
          <input
            type="checkbox"
            [checked]="isChecked(filter.name, field.value)"
            (change)="toggleCheckbox(filter.name, field.value)"
          />
          <span class="checkmark"></span>
          {{ field.name }}
        </label>
        }
      </div>
    </div>
    @for (dd of dropdownsAfter(filter.name); track dd.key) {
      <app-dropdown
        [label]="dd.label"
        [placeholder]="dd.placeholder"
        [options]="dd.options"
        [type]="dd.type"
        [ngModel]="dropdownModels().get(dd.key)"
        (ngModelChange)="onDropdownModelChange(dd, $event)"
        [name]="dd.key"
        [isSearch]="dd.isSearch || false"
        [isFilterClass]="dd.isFilterClass || false"
      ></app-dropdown>
    }
    } }
  </div>

  <div class="footer">
    <app-button buttonVariant="filter-dialog-secondary" buttonType="button" (buttonClick)="onReset()">Reset</app-button>
    <app-button
      buttonVariant="filter-dialog-primary"
      buttonType="button"
      [state]="applyState"
      (buttonClick)="onApply()"
    >
      Apply
    </app-button>
  </div>
</div>
